(function(window, undefined) {

    'use strict';

    /*global flensed:false */



    SAPO.namespace('Communication');



    /**
     * github repository: https://github.com/flensed/flXHR
     *
     * flXHR docs: https://github.com/flensed/flXHR/blob/master/documentation-flXHR.md
     *
     * flXHR relies on the following files being available in the same dir (of flXHR.js):
     * - flensed.js
     * - checkplayer.js
     * - swfobject.js
     * - flXHR.swf
     * - flXHR.vbs (only needed to emulate the binary object 'responseBody' property in IE browsers)
     */

    /**
     * @function ?
     * @param  {String}    uri               address to use
     * @param  {optional Object}  options    additional options
     * @...    {optional String}  method     defaults to 'GET'. can be 'GET', 'POST'
     * @...    {optional String}  format     defaults to ''. can be '', 'xml', 'json'
     * @...    {optional String}  data       data to send. defaults to ''
     * @...    {optional Number}  timeout    timeout, in seconds, defaults to no timeout at all
     * @...    {optional Object}  headers    object with headers to send. Because of restrictions imposed by the Flash Player plugin, only a subset of standard HTTP request headers may be set, as well as any custom headers; others will silently be ignored, resulting in security sandbox errors.
     * @...    {optional String}  policyURI  where can the crossdomain.xml be found? set if different from root.
     * @param  {Function}         cb         receives (err, data)
     */
    SAPO.Communication.CorsInFlash = function(uri, options, cb) {
        /*jshint maxcomplexity:20 */
        // options are optional
        if (typeof options === 'function') {
            cb = options;
            options = {};
        }

        // arguments validation
        if (typeof uri !== 'string') {
            throw new Error('uri must be a string');
        }
        if (typeof options !== 'object') {
            throw new Error('options must be an object');
        }
        if (typeof cb !== 'function') {
            throw new Error('cb must be a function');
        }

        var ext = uri.split('.').pop();
        var inXML  = (options.format === 'xml')    || ext === 'xml';
        var inJSON = (options.format === 'json')   || ext === 'json';
        var inBin  = (options.format === 'binary');

        var flProxy = new flensed.flXHR({
            //autoUpdatePlayer:   true,    // ??
            binaryResponseBody: inBin,
            sendTimeout:        (options.timeout * 1000) || -1
        });

        if (options.policyURI) {
            flProxy.loadPolicyURL = options.policyURI;
        }

        if (options.headers) {
            for (var k in options.headers) {
                flProxy.setRequestHeader(k, options.headers[k]);
            }
        }

        flProxy.xmlResponseText = inXML;

        var errFn = function(err) {
            cb(
                ('name' in err) ? 'error' : 'timeout'
            );
            flProxy.Destroy();
        };

        flProxy.onerror   = errFn;
        flProxy.ontimeout = errFn;
        flProxy.onreadystatechange = function(o) { // flProxy is this in cb - can do this.getAllResponseHeaders();
            //console.log('flXHR state ', o.readyState);
            if (o.readyState === 4) {
                var r;
                if      (inJSON) { r = JSON.parse(o.responseText); }
                else if (inXML) {  r = o.responseXML; }
                else if (inBin) {  r = flProxy.responseBody; }
                else {             r = o.responseText; }
                cb.call(flProxy, null, r, o.status, o.statusText);
                //console.log('RESPONSE TEXT:\n', o.responseText);
                flProxy.Destroy();
            }
        };

        flProxy.open(options.method || 'GET', uri);

        flProxy.send(options.data || '');
    };

})(window);
